(function () {
  'use strict';

  var GLOBAL_KEY = '__vdBrandsMarqueeController';

  /*
   * Aynı asset bir sayfada birden fazla Brands section
   * tarafından çağrılsa bile global event'leri yalnızca
   * bir kez kur.
   */
  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initAll(document);
    return;
  }

  var SELECTOR = '[data-brands-marquee]';

  var DRAG_THRESHOLD = 6;
  var RESUME_DELAY = 450;
  var MAX_FRAME_DELTA = 0.25;

  var instances = new WeakMap();

  /* =========================================
     MARQUEE INSTANCE
     ========================================= */

  function createMarquee(root) {
    if (!root) return null;

    var existing = instances.get(root);

    if (existing) {
      return existing;
    }

    var track = root.querySelector('.wt-brands__marquee-track');
    var group = root.querySelector('.wt-brands__marquee-group');

    if (!track || !group) {
      return null;
    }

    var speed = parseFloat(root.dataset.speed);

    if (!isFinite(speed) || speed <= 0) {
      speed = 60;
    }

    var manualDrag = root.dataset.manualDrag === 'true';

    var offset = 0;
    var groupWidth = 0;

    var rafId = null;
    var lastTime = null;

    var resumeTimer = null;

    var isVisible = true;
    var destroyed = false;

    var pointerIsDown = false;
    var isDragging = false;
    var pointerId = null;

    var startX = 0;
    var startY = 0;
    var startOffset = 0;

    var horizontalIntent = false;
    var verticalIntent = false;

    var suppressNextClick = false;

    var intersectionObserver = null;
    var resizeObserver = null;

    var mediaQuery = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    var reduceMotion = mediaQuery ? mediaQuery.matches : false;

    root.dataset.brandsMarqueeInitialized = 'true';

    /* =========================================
       POSITION / MEASUREMENT
       ========================================= */

    function normalizeOffset() {
      if (!groupWidth) return;

      /*
       * Modulo yerine while kullanımı burada bilinçli.
       * Normal kullanımda offset yalnızca çok küçük
       * miktarlarda sınırı aşar.
       */
      while (offset <= -groupWidth) {
        offset += groupWidth;
      }

      while (offset > 0) {
        offset -= groupWidth;
      }
    }

    function render() {
      if (destroyed) return;

      track.style.transform =
        'translate3d(' + offset.toFixed(3) + 'px, 0, 0)';
    }

    function measure() {
      if (destroyed || !root.isConnected) return;

      var measuredWidth = group.getBoundingClientRect().width;

      if (!measuredWidth || !isFinite(measuredWidth)) {
        groupWidth = 0;
        return;
      }

      groupWidth = measuredWidth;

      normalizeOffset();
      render();
    }

    /* =========================================
       AUTO MARQUEE
       ========================================= */

    function shouldAnimate() {
      return (
        !destroyed &&
        !reduceMotion &&
        !document.hidden &&
        isVisible &&
        !pointerIsDown &&
        !isDragging &&
        groupWidth > 0 &&
        root.isConnected
      );
    }

    function stopAnimation() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }

      lastTime = null;
    }

    function frame(now) {
      rafId = null;

      if (!shouldAnimate()) {
        lastTime = null;
        return;
      }

      if (lastTime === null) {
        lastTime = now;
      } else {
        var delta = (now - lastTime) / 1000;

        /*
         * Main thread uzun süre bloklanırsa geri dönüşte
         * büyük bir görsel sıçrama oluşmasını engeller.
         */
        if (delta > MAX_FRAME_DELTA) {
          delta = MAX_FRAME_DELTA;
        }

        offset -= speed * delta;

        normalizeOffset();
        render();

        lastTime = now;
      }

      if (shouldAnimate()) {
        rafId = requestAnimationFrame(frame);
      }
    }

    function startAnimation() {
      if (!shouldAnimate()) return;
      if (rafId !== null) return;

      lastTime = null;
      rafId = requestAnimationFrame(frame);
    }

    function scheduleResume() {
      clearTimeout(resumeTimer);

      resumeTimer = setTimeout(function () {
        resumeTimer = null;

        if (!destroyed) {
          startAnimation();
        }
      }, RESUME_DELAY);
    }

    /* =========================================
       POINTER STATE
       ========================================= */

    function resetPointerState() {
      pointerIsDown = false;
      isDragging = false;
      pointerId = null;

      horizontalIntent = false;
      verticalIntent = false;

      suppressNextClick = false;

      root.classList.remove('is-dragging');
    }

    function onPointerDown(event) {
      if (!manualDrag || destroyed) return;

      /*
       * Desktop'ta yalnızca sol mouse tuşu.
       */
      if (event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }

      clearTimeout(resumeTimer);
      resumeTimer = null;

      pointerIsDown = true;
      isDragging = false;

      pointerId = event.pointerId;

      startX = event.clientX;
      startY = event.clientY;
      startOffset = offset;

      horizontalIntent = false;
      verticalIntent = false;

      suppressNextClick = false;

      /*
       * Kullanıcı etkileşime başladığında marquee durur.
       * Böylece logo pointer'ın altından kaçmaz.
       */
      stopAnimation();
    }

    function onPointerMove(event) {
      if (!manualDrag || destroyed) return;
      if (!pointerIsDown) return;
      if (event.pointerId !== pointerId) return;

      var deltaX = event.clientX - startX;
      var deltaY = event.clientY - startY;

      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);

      /*
       * Önce kullanıcının gerçek hareket yönünü belirle.
       */
      if (!horizontalIntent && !verticalIntent) {
        if (
          absX < DRAG_THRESHOLD &&
          absY < DRAG_THRESHOLD
        ) {
          return;
        }

        if (absX > absY) {
          horizontalIntent = true;
          isDragging = true;
          suppressNextClick = true;

          root.classList.add('is-dragging');
        } else {
          /*
           * Dikey hareket sayfa scroll'una bırakılır.
           */
          verticalIntent = true;
          return;
        }
      }

      if (verticalIntent || !horizontalIntent) {
        return;
      }

      /*
       * Gerçek yatay drag başladığında browser'ın
       * kendi yatay gesture davranışını engelle.
       */
      if (event.cancelable) {
        event.preventDefault();
      }

      offset = startOffset + deltaX;

      normalizeOffset();
      render();
    }

    function finishPointer(event) {
      if (!manualDrag || destroyed) return;
      if (!pointerIsDown) return;

      if (
        event &&
        event.pointerId !== undefined &&
        pointerId !== null &&
        event.pointerId !== pointerId
      ) {
        return;
      }

      var wasDragging = isDragging;

      pointerIsDown = false;
      isDragging = false;
      pointerId = null;

      horizontalIntent = false;
      verticalIntent = false;

      root.classList.remove('is-dragging');

      normalizeOffset();
      render();

      /*
       * Normal tap/click ise link çalışabilir.
       * Drag yapıldıysa oluşabilecek sonraki click
       * onClick tarafından engellenecek.
       */
      if (!wasDragging) {
        suppressNextClick = false;
      }

      scheduleResume();
    }

    function onWindowBlur() {
      if (!pointerIsDown || destroyed) return;

      /*
       * Pointer browser penceresi dışında bırakılırsa
       * marquee'nin sonsuza kadar paused kalmasını önle.
       */
      pointerIsDown = false;
      isDragging = false;
      pointerId = null;

      horizontalIntent = false;
      verticalIntent = false;

      suppressNextClick = false;

      root.classList.remove('is-dragging');

      normalizeOffset();
      render();

      scheduleResume();
    }

    /* =========================================
       CLICK / NATIVE DRAG
       ========================================= */

    function onClick(event) {
      if (!manualDrag || !suppressNextClick || destroyed) {
        return;
      }

      var link = event.target.closest('.wt-brands__link');

      if (!link || !root.contains(link)) {
        return;
      }

      /*
       * Gerçek drag sonrası oluşan sentetik click
       * marka sayfasını yanlışlıkla açmasın.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      suppressNextClick = false;
    }

    function onDragStart(event) {
      if (!manualDrag || destroyed) return;

      if (
        event.target.closest(
          '.wt-brands__link, .wt-brands__image'
        )
      ) {
        event.preventDefault();
      }
    }

    /* =========================================
       VISIBILITY / PAGE STATE
       ========================================= */

    function onVisibilityChange() {
      if (destroyed) return;

      if (document.hidden) {
        stopAnimation();
        return;
      }

      lastTime = null;

      measure();
      startAnimation();
    }

    function onPageShow() {
      if (destroyed) return;

      resetPointerState();

      stopAnimation();

      measure();
      startAnimation();
    }

    function onReducedMotionChange(event) {
      reduceMotion = event.matches;

      if (reduceMotion) {
        stopAnimation();
      } else {
        lastTime = null;

        measure();
        startAnimation();
      }
    }

    /* =========================================
       OBSERVERS
       ========================================= */

    if ('IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(
        function (entries) {
          if (destroyed) return;

          entries.forEach(function (entry) {
            if (entry.target !== root) return;

            isVisible = entry.isIntersecting;

            if (isVisible) {
              lastTime = null;

              measure();
              startAnimation();
            } else {
              stopAnimation();
            }
          });
        },
        {
          rootMargin: '100px 0px 100px 0px'
        }
      );

      intersectionObserver.observe(root);
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        if (destroyed) return;

        measure();
      });

      resizeObserver.observe(group);
      resizeObserver.observe(root);
    }

    /* =========================================
       EVENTS
       ========================================= */

    root.addEventListener(
      'pointerdown',
      onPointerDown
    );

    root.addEventListener(
      'click',
      onClick,
      true
    );

    root.addEventListener(
      'dragstart',
      onDragStart
    );

    window.addEventListener(
      'pointermove',
      onPointerMove,
      { passive: false }
    );

    window.addEventListener(
      'pointerup',
      finishPointer
    );

    window.addEventListener(
      'pointercancel',
      finishPointer
    );

    window.addEventListener(
      'blur',
      onWindowBlur
    );

    document.addEventListener(
      'visibilitychange',
      onVisibilityChange
    );

    window.addEventListener(
      'pageshow',
      onPageShow
    );

    if (!resizeObserver) {
      window.addEventListener(
        'resize',
        measure,
        { passive: true }
      );
    }

    if (mediaQuery) {
      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener(
          'change',
          onReducedMotionChange
        );
      } else if (typeof mediaQuery.addListener === 'function') {
        /*
         * Eski Safari fallback.
         */
        mediaQuery.addListener(
          onReducedMotionChange
        );
      }
    }

    /* =========================================
       CLEANUP
       ========================================= */

    function destroy() {
      if (destroyed) return;

      destroyed = true;

      clearTimeout(resumeTimer);
      resumeTimer = null;

      stopAnimation();

      if (intersectionObserver) {
        intersectionObserver.disconnect();
        intersectionObserver = null;
      }

      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }

      root.removeEventListener(
        'pointerdown',
        onPointerDown
      );

      root.removeEventListener(
        'click',
        onClick,
        true
      );

      root.removeEventListener(
        'dragstart',
        onDragStart
      );

      window.removeEventListener(
        'pointermove',
        onPointerMove
      );

      window.removeEventListener(
        'pointerup',
        finishPointer
      );

      window.removeEventListener(
        'pointercancel',
        finishPointer
      );

      window.removeEventListener(
        'blur',
        onWindowBlur
      );

      document.removeEventListener(
        'visibilitychange',
        onVisibilityChange
      );

      window.removeEventListener(
        'pageshow',
        onPageShow
      );

      if (!resizeObserver) {
        window.removeEventListener(
          'resize',
          measure
        );
      }

      if (mediaQuery) {
        if (typeof mediaQuery.removeEventListener === 'function') {
          mediaQuery.removeEventListener(
            'change',
            onReducedMotionChange
          );
        } else if (typeof mediaQuery.removeListener === 'function') {
          mediaQuery.removeListener(
            onReducedMotionChange
          );
        }
      }

      resetPointerState();

      track.style.transform = '';

      delete root.dataset.brandsMarqueeInitialized;

      instances.delete(root);
    }

    var instance = {
      root: root,
      measure: measure,
      start: startAnimation,
      stop: stopAnimation,
      destroy: destroy
    };

    instances.set(root, instance);

    /* =========================================
       INITIAL START
       ========================================= */

    measure();
    startAnimation();

    return instance;
  }

  /* =========================================
     INITIALIZATION
     ========================================= */

  function initRoot(root) {
    if (!root || !root.matches || !root.matches(SELECTOR)) {
      return null;
    }

    return createMarquee(root);
  }

  function initAll(scope) {
    var context = scope || document;

    if (
      context.matches &&
      context.matches(SELECTOR)
    ) {
      initRoot(context);
    }

    if (!context.querySelectorAll) return;

    var roots = context.querySelectorAll(SELECTOR);

    roots.forEach(function (root) {
      initRoot(root);
    });
  }

  /* =========================================
     DESTROY SECTION
     ========================================= */

  function destroyAll(scope) {
    if (!scope) return;

    if (
      scope.matches &&
      scope.matches(SELECTOR)
    ) {
      var directInstance = instances.get(scope);

      if (directInstance) {
        directInstance.destroy();
      }
    }

    if (!scope.querySelectorAll) return;

    var roots = scope.querySelectorAll(SELECTOR);

    roots.forEach(function (root) {
      var instance = instances.get(root);

      if (instance) {
        instance.destroy();
      }
    });
  }

  /* =========================================
     SHOPIFY THEME EDITOR
     ========================================= */

  function onSectionLoad(event) {
    initAll(event.target);
  }

  function onSectionUnload(event) {
    destroyAll(event.target);
  }

  document.addEventListener(
    'shopify:section:load',
    onSectionLoad
  );

  document.addEventListener(
    'shopify:section:unload',
    onSectionUnload
  );

  /* =========================================
     GLOBAL CONTROLLER
     ========================================= */

  var controller = {
    initAll: initAll,
    destroyAll: destroyAll
  };

  window[GLOBAL_KEY] = controller;

  /* =========================================
     BOOT
     ========================================= */

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once: true }
    );
  } else {
    boot();
  }
})();